import { HttpClient } from '@angular/common/http';
import { IonInput } from '@ionic/angular';
import pdfMake from 'pdfmake/build/pdfmake';
import vfs from 'pdfmake/build/vfs_fonts';
import { DbService } from '../services/db/db.service';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from './dialog/dialog.component';
import { DataSharingService } from '../services/data-sharing/data-sharing.service';
import { Observable, switchMap } from 'rxjs';
import { Big as BigDecimal } from 'big.js';
import { Chart, registerables } from 'chart.js';
// import {LohnsteuerService2024} from '../services/lohnsteuer/lohonsteuer.service-2024';
// import {LohnsteuerService2024Dez} from '../services/lohnsteuer/lohonsteuer.service-2024-Dez';
import { Lohnsteuer2025Service } from '../services/lohnsteuer/lohonsteuer2025.service';
import { BikeCategory } from '../services/module/BikeCategory';
import { PRICE_CATEGORY } from '../services/module/PriceCategory';
import { PRICE_CATEGORY_INSPECTION } from '../services/module/InspectionPacket';
import { ActivatedRoute } from '@angular/router';

pdfMake.vfs = vfs;

@Component({
  selector: 'app-rechner',
  templateUrl: './rechner.page.html',
  styleUrls: ['./rechner.page.scss'],
})
export class RechnerPage implements OnInit, OnChanges, OnDestroy {
  @ViewChild('myInput', { static: false }) myInput: IonInput;
  @ViewChild('chartCanvas') chartCanvas!: ElementRef<HTMLCanvasElement>;
  punkte: { x: number; y: number }[] = [];
  punkte2: { x: number; y: number }[] = [];
  chart: Chart | null = null;
  private outOnePercentAbzug: number;

  GwV = 0.0025;

  varRV = 0.093;
  varAV = 0.013;

  // Variable für InfoMessage
  public currInfo = '';

  ergebnis = false;
  modusSpezial = false;
  // Variablen für Ergebnisse
  outBruttoMonat: number;
  outVersAN: number;
  outVersAN1: number;
  outVersANVergleich: number;
  outInspektion: number;
  outAGAnteil: number;
  outGwV: number;
  outLeasingrate: number;
  outlSt1: number;
  outlSt2: number;
  outSoliZ1: number;
  outSoliZ2: number;
  outKiSt1: number;
  outKiSt2: number;
  // tslint:disable-next-line:variable-name
  zs1_2: number;
  // tslint:disable-next-line:variable-name
  zs2_2: number;
  outBasisSV1: number;
  outBasisSV2: number;
  outRV1: number;
  outRV2: number;
  outKV1: number;
  outKV2: number;
  outPV1: number;
  outPV2: number;
  outAV1: number;
  outAV2: number;
  // tslint:disable-next-line:variable-name
  zs1_3: number;
  // tslint:disable-next-line:variable-name
  zs2_3: number;
  outNettogehalt1: number;
  outNettogehalt2: number;
  outKaufpreis: number;
  outGesKostenLZ1: number;
  outGesKostenLZ2: number;
  outErsparnisRel: number;
  outErsparnisFix: number;
  outVBLbeitrag1: number;
  outVBLbeitrag2: number;
  uebernahmepreis: number;

  outpkv: number;
  outpkvA: number;
  outpvsumm: number;
  outuvp: number;
  outOnePercent: number;
  outOnePercentNetto: number;
  Premiumplus: number;
  outLeasingduration: number;
  varBruttoJahr = 0;
  zvE: number;
  zvE2: number;

  title: string;
  logoForPDFBase64: any | ArrayBuffer;
  // 0 bis 1000 => 0
  // 1001 bis 1500 index 1
  private versicherungValue: { BARMENIA: number[][]; HEPSTER: number[][] } = {
    BARMENIA: [
      [
        4.76, 7.96, 8.81, 10.94, 13.42, 15.59, 17.55, 19.73, 21.87, 24.05,
        26.22, 28.39, 30.56, 32.73, 34.68, 36.85, 39.02, 41.19, 43.36, 45.53,
      ],
      [
        6.36, 11.31, 11.98, 12.65, 13.31, 15.91, 18.4, 21.0, 23.58, 26.07,
        28.68, 31.3, 33.78, 36.38, 38.97, 41.46, 44.06, 46.66, 49.15, 51.75,
      ],
    ],
    /* upgrade Bestandskunden */
    HEPSTER: [
      [
        3.37, 5.65, 8.08, 10.4, 12.73, 14.75, 16.58, 18.61, 20.62, 22.65, 24.68,
        26.7, 28.73, 30.75, 32.58, 34.6, 36.63, 38.65, 40.68, 42.7,
      ],
      [
        6.13, 10.75, 11.38, 12.0, 12.63, 15.05, 17.38, 19.8, 22.22, 24.54,
        26.97, 29.41, 31.73, 34.15, 36.58, 38.9, 41.33, 43.75, 46.08, 48.5,
      ],
    ],
    // /* ualtes Produkt 24.04.2025 */
    // HEPSTER: [
    //   [
    //     4.50, 8.50, 8.50, 8.50, 8.50, 10.30, 12.00, 13.80, 15.59, 17.29,
    //     19.09, 20.91, 22.60, 24.40, 26.20, 27.90, 29.70, 31.50, 33.20, 35.00
    //   ],
    //   [
    //     1.74, 3.40, 5.20, 6.90, 8.60, 10.00, 11.20, 12.61, 13.99, 15.40, 16.80,
    //     18.20, 19.60, 21.00, 22.20, 23.60, 25.00, 26.40, 27.80, 29.20
    //   ],
    // ],
    /* altes Produkt */
    // Hepster 1 und 2 index sind gleich
    // HEPSTER: [
    //   [
    //     4.37, 6.65, 9.08, 11.4, 13.73, 15.75, 17.58, 19.61, 21.62, 23.65, 25.68,
    //     27.7, 29.73, 31.75, 33.58, 35.6, 37.63, 39.65, 41.68, 43.7,
    //   ],
    //   [
    //     7.13, 11.75, 12.38, 13.0, 13.63, 16.05, 18.38, 20.8, 23.22, 25.54,
    //     27.97, 30.41, 32.37, 35.15, 37.58, 39.9, 42.33, 44.75, 47.08, 49.5,
    //     49.5,
    //   ],
    // ],
  };
  private PremiumplusValue: { BARMENIA: number[]; HEPSTER: number[] } = {
    BARMENIA: [
      0.67, 1.34, 2.01, 2.68, 3.35, 4.02, 4.69, 5.36, 6.02, 6.69, 7.36, 8.03,
      8.7, 9.3, 10.04, 10.71, 11.38, 12.05, 12.72, 13.39,
    ],
    HEPSTER: [
      0.63, 1.25, 1.88, 2.5, 3.13, 3.75, 4.38, 5.0, 5.63, 6.25, 6.88, 7.5, 8.13,
      8.75, 9.38, 10.0, 10.63, 11.25, 11.88, 12.5,
    ],
  };
  // Stafflung for Hepsterinsurance Basis
  private B_STAFFELUNG = [
    0.97, 1.94, 2.91, 3.88, 4.85, 5.82, 6.79, 7.76, 7.81, 7.86, 10.67, 11.64,
    12.61, 13.58, 14.55,
  ];
  private C_STAFFELUNG = [
    1.56, 3.13, 4.69, 6.26, 7.82, 9.39, 10.95, 12.51, 14.08, 15.64, 17.21,
    18.77, 20.34, 21.9, 23.46,
  ];
  private zvEMitStAbzug = 0;
  private outlStMitStAbzug = 0;
  public outVBLbeitragMitStAbzug = 0;
  public outNettogehaltMitStAbzug = 0;
  // tslint:disable-next-line:variable-name
  private zs2_2MitStAbzug = 0;
  private outRV2MitStAbzug = 0;
  // tslint:disable-next-line:variable-name
  private zs2_3MitStAbzug = 0;
  private outKV2MitStAbzug = 0;
  private outPV2MitStAbzug = 0;
  private outAV2MitStAbzug = 0;
  private outKiStMitStAbzug = 0;
  public inputValue = '';
  public previousDsCode = 'q';
  public vollkaskover = 0;
  public leasingfaktor = 0.0325;
  public differenceInMonths = 0;
  public showBusinessLogo = false;
  private berechnent = false;
  userEditedInspektion = false;

  isValid = true;
  private rvBG = 8050;
  // Rag-1224
  private rvBG_RAG = 9900;
  private KPVBemessungsgrenze = 5512.5;
  // Diff zwischen Sachen und adneren Nundesländer ist 0.5
  // man kan den zweitenfeld löschen, aber so ist es verständlicher
  private pvSatz: number[] = [2.4, 1.8, 1.55, 1.3, 0.105, 0.8];
  private pvSatzSachsen: number[] = [2.9, 2.3, 2.05, 1.8, 1.55, 1.3];
  // check Lohnsteuer
  private aVBG = 8050;
  private rvValueVar: boolean;
  private kvValueVar: string;
  private pkvValueVar = 0;
  private pvAnteilVar = 0;
  private VBLVar: number;
  private leasingfaktorVar: number;
  protected ustAgVar = 1;
  private uebernahmeprozent = 0.18;

  constructor(
    private http: HttpClient,
    private dialog: MatDialog,
    public dSS: DataSharingService,
    private firebaseService: DbService,
  ) {
    firebaseService.add();
  }

  public data$: Observable<any>;

  route = inject(ActivatedRoute);
  ngOnInit() {
    console.log('INIT');
    this.route.queryParams.subscribe((params) => {
      if (params.id) {
        this.dSS.dsCode = params.id;
      }
      if (params['source'] === 'business') {
        this.showBusinessLogo = true;
        this.dSS.dsCode = 'Test-5555';
      }
    });

    // subscribe to changes in all component!
    this.dSS.changes$.subscribe((next) => {
      if (next === 'bArt') {
        if (this.dSS.bArt === 0) {
          this.ustAgVar = this.dSS.dienststelle.ustAGBeamte;
          this.rvValueVar = false;
          this.dSS.rvValue = false;
          this.kvValueVar = 'pvo';
          this.dSS.kvValue = 'pvo';
          this.VBLVar = 0;
          this.dSS.dienststelle.VBL = 0;
        }
      }
      if (!next) {
        this.vorsteuerAbzugsberechtigtDateChange();
      } else if (this.dSS.dienststelle) {
        this.berechnen();
      }
    });

    this.dSS.data$
      .pipe(
        switchMap((newInputValue) =>
          this.firebaseService.getDienststelleData(
            this.capitalizeFirstLetter(newInputValue),
          ),
        ),
      )
      .subscribe((res) => {
        if (res) {
          this.inputValue = this.dSS.dsCode;
          this.dSS.updateDienststelle(res);
          this.dSS.dienststelle = res;
          this.dSS.dienststelle.VBL *= 100;
          this.dSS.showFairbetrag = !!res.fairbetrag;
          this.dSS.inspectionDisabled = false;
          if (
            this.dSS.dienststelle.ustAb &&
            this.dSS.dienststelle.ustAb !== ''
          ) {
            this.dSS.selectedDate = new Date(this.dSS.dienststelle.ustAb);
            this.vorsteuerAbzugsberechtigtDateChange();
            this.berechnerDiff();
          }
          if (!this.dienststelleValid()) {
            const result = this.openDialogDataNotValid();
            if (result) {
              this.inputValue = this.dSS.dsCode;
              this.onInputChange();
            } else {
              console.error('Dienststelle nicht gefunden!');
            }
          }

          if (this.inputValue.toLowerCase() === 'rag-1224') {
            this.rvBG = this.rvBG_RAG;
          } else {
            this.rvBG = 8050;
          }

          if (
            ['rag-1224', 'rmi-0125'].includes(this.inputValue.toLowerCase())
          ) {
            this.dSS.zusatzValue = 4.4;
          } else {
            this.dSS.zusatzValue = 2.5;
          }

          if (
            ['obe-1024', 'sso-1224', 'tho-0325'].includes(
              this.inputValue.toLowerCase(),
            )
          ) {
            this.leasingfaktorVar = 0.032;
          }

          if (this.dSS.bArt === 0) {
            this.ustAgVar = this.dSS.dienststelle.ustAGBeamte;
            this.rvValueVar = false;
            this.dSS.rvValue = false;
            this.kvValueVar = 'pvo';
            this.dSS.kvValue = 'pvo';
            this.VBLVar = 0;
            this.dSS.dienststelle.VBL = 0;
          }

          if (this.berechnent) {
            this.berechnen();
          }
        } else {
          const result = this.openDialog();
          if (result) {
            this.inputValue = '';
            this.onInputChange();
          } else {
            console.error('Dienststelle nicht gefunden!');
          }
        }
      });

    this.loadLocalAssetToBase64();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dSS.inputChanged.next(true);
    // test comment
  }

  get isNameChanged(): boolean {
    return this.inputValue !== this.previousDsCode;
  }

  ionViewDidEnter() {
    this.myInput.setFocus();
  }

  berechnen() {
    /***
     *     const params = {
     *       RE4: 4500,
     *       PKV: 1,
     *       ALTER1: 0,
     *       af: 0,
     *       f: 1,
     *       PVS: 0,
     *       R: 0,
     *       LZZHINZU: 0,
     *       PVZ: 0,
     *       STKL: 1,
     *       LZZ: 2,
     *       KRV: 2}; // Provide the necessary parameters
     * ***/

    this.berechnent = true;

    if (this.dataValid()) {
      const bArt = this.dSS.bArt;
      this.ustAgVar = this.dSS.dienststelle.ustAG;
      this.rvValueVar = this.dSS.rvValue;
      this.kvValueVar = this.dSS.kvValue;
      this.pvAnteilVar = this.dSS.pvAnteil;
      this.pkvValueVar = this.dSS.pkvValue;
      // TODO change in neu structure Arbeitnehmner haben kein VBL
      this.VBLVar = bArt === 2 ? 0 : this.dSS.dienststelle.VBL;
      if (this.dSS.isVivantes()) {
        const a = this.getPricing(
          this.dSS.bikeCategory as BikeCategory,
          this.dSS.kaufpreis / 1.19,
        );
        this.leasingfaktorVar = a.leasingfaktor / 100;
        this.uebernahmeprozent = a.uebernahmeprozent / 100;
      } else if (
        ['obe-1024', 'sso-1224', 'tho-0325'].includes(
          this.inputValue.toLowerCase(),
        )
      ) {
        if (this.dSS.kaufpreis > 1000) {
          this.leasingfaktorVar = 0.032;
        } else {
          this.leasingfaktorVar = 0.03;
        }
      } else {
        this.leasingfaktorVar = this.dSS.dienststelle.leasingfaktor;
        this.uebernahmeprozent = this.dSS.dienststelle.uebernahmeprozent;
      }

      // if (bArt === 0) {
      //   this.ustAgVar = this.dSS.dienststelle.ustAGBeamte;
      //   this.rvValueVar = false;
      //   this.kvValueVar = 'pvo';
      //   this.pkvValueVar = 0;
      //   this.VBLVar = 0;
      // }

      // Falls anzahl der Monaten 24 oder 30 ist, werden Leasingfaktor und Übernahmeprozent überschrieben
      if (this.dSS.leasingDuration === 24) {
        this.leasingfaktorVar = 0.0484;
        this.uebernahmeprozent = 0.25;
      } else if (this.dSS.leasingDuration === 30) {
        this.leasingfaktorVar = 0.0392;
        this.uebernahmeprozent = 0.22;
      }

      this.outuvp =
        this.dSS.bruttoKaufUVP === 0
          ? this.dSS.kaufpreis
          : this.dSS.bruttoKaufUVP;

      this.outGwV = Math.floor(this.GwV * this.outuvp);

      this.outpkv = 0;
      this.outpkvA = 0;
      this.outpvsumm = 0;
      // TODO remove jahres Einkommen
      this.varBruttoJahr = this.dSS.bruttogehalt * 12;
      this.outBruttoMonat = this.dSS.bruttogehalt;
      // FIXME check if the leasingDuration is set correctly
      this.outLeasingduration = this.dSS.leasingDuration;

      this.berechneVollKasko();
      this.outVersAN1 = this.outVersANVergleich;
      const isKalRadimdienst = [
        'kal-radimdienst',
        'kal-radimdienst',
        'kal-radimdienst',
      ].includes(this.dSS.dsCode?.toLowerCase());

      if (
        this.dSS.dienststelle.sonderInspektion &&
        this.dSS.dienststelle.sonderInspektion !== 0
      ) {
        if (this.dSS.isVivantes()) {
          // isOptionsExtended is for a client always true of false
          // no need to save the previous value of sonderInspection
          const inspectionPrices = this.getInspectionCustomPreis();
          if (!(isKalRadimdienst && this.userEditedInspektion)) {
            this.outInspektion = inspectionPrices.monthly;
          }
          this.dSS.dienststelle.sonderInspektion = inspectionPrices.total;
        } else {
          if (!(isKalRadimdienst && this.userEditedInspektion)) {
            this.outInspektion = this.dSS.dienststelle.sonderInspektion;
          }
        }
      }

      if (this.ustAgVar === 1) {
        if (!(isKalRadimdienst && this.userEditedInspektion)) {
          this.outInspektion = this.outInspektion / 1.19;
        }

        this.outLeasingrate = this.euro(
          (this.dSS.getKaufpreis() * this.leasingfaktorVar) /
            (this.dSS.useNetBikePrice ? 1 : 1.19),
        );
      } else {
        this.outLeasingrate = this.euro(
          this.dSS.getKaufpreis() * this.leasingfaktorVar,
        );
      }

      if (!(isKalRadimdienst && this.userEditedInspektion)) {
        this.outInspektion =
          this.dSS.dienststelle.inspektion !== 0 ? this.outInspektion : 0;
      }

      this.updateFairbetrag();
      this.updateVorsteuerAndOneProzent();

      // zvE = zu versteuerndes Einkommen
      this.zvE = this.dSS.bruttogehalt;
      this.berechneUmwandlungsRate();

      // lSt = Lohnsteuer
      let steuerResults = this.lohnSteuer(this.zvE);
      this.outlSt1 = steuerResults[0];
      this.outKiSt1 = steuerResults[1];

      steuerResults = this.lohnSteuer(this.zvE2);
      this.outlSt2 = steuerResults[0];
      this.outKiSt2 = steuerResults[1];

      if (this.ustAgVar === 2) {
        this.berechneUmwandlungsRateAbzug();
        steuerResults = this.lohnSteuer(this.zvEMitStAbzug);
        this.outlStMitStAbzug = steuerResults[0];
        this.outKiStMitStAbzug = steuerResults[1];
      }

      // outSoli = 0
      this.outSoliZ1 = 0;
      this.outSoliZ2 = 0;

      this.zs1_2 = this.outlSt1 + this.outSoliZ1 + this.outKiSt1;
      this.zs2_2 = this.outlSt2 + this.outSoliZ2 + this.outKiSt2;
      if (this.ustAgVar === 2) {
        this.outSoliZ2 = 0;
        this.zs2_2MitStAbzug =
          this.outlStMitStAbzug + this.outSoliZ2 + this.outKiStMitStAbzug;
      }
      // Variable werden nicht verwendet!
      // zu Versteuerndes Einkommen + Kirchensteuer + Lohnsteuer + Solidaritätszuschlag
      this.outBasisSV1 = this.zvE + this.zs1_2;
      this.outBasisSV2 = this.zvE2 + this.zs2_2;

      this.berechneRentenVersicherung();

      this.outKV1 = this.berechneKV(this.zvE);
      this.outKV2 = this.berechneKV(this.zvE2);
      if (this.ustAgVar === 2) {
        this.outKV2MitStAbzug = this.berechneKV(this.zvEMitStAbzug);
      }

      this.beamtegesetzlichKV();
      this.KrankenversicherungBeamte1();

      this.outPV1 = this.berechnePv(this.zvE);
      this.outPV2 = this.berechnePv(this.zvE2);
      this.outPV2MitStAbzug = this.berechnePv(this.zvEMitStAbzug);

      this.beamtepflegeversicherung();
      this.outVBLbeitrag1 = this.zuSatzVersorgung(this.zvE);
      // Zusatzversorgung wird ohne GwV berechnet
      this.outVBLbeitrag2 = this.zuSatzVersorgung(this.zvE2 - this.outGwV);

      if (this.ustAgVar === 2) {
        this.outVBLbeitragMitStAbzug = this.zuSatzVersorgung(
          this.zvEMitStAbzug - this.outGwV,
        );
      }

      // AV = Arbeitslosenversicherung; AN/AG je 1,2 % bis 6.900 EUR (West) bzw. 6.450 EUR (Ost) beitragspfl. Entgelt
      this.outAV1 = this.berechneAV(this.zvE);
      this.outAV2 = this.berechneAV(this.zvE2);
      this.outAV2MitStAbzug = this.berechneAV(this.zvEMitStAbzug);

      this.beamte1();
      this.zs1_3 = this.outRV1 + this.outKV1 + this.outPV1 + this.outAV1;
      this.zs2_3 = this.outRV2 + this.outKV2 + this.outPV2 + this.outAV2;

      if (this.ustAgVar === 2) {
        this.zs2_3MitStAbzug =
          this.outRV2MitStAbzug +
          this.outKV2MitStAbzug +
          this.outPV2MitStAbzug +
          this.outAV2MitStAbzug;
      }

      this.outNettogehalt1 = this.zvE - this.zs1_2 - this.zs1_3;
      this.outNettogehalt2 = this.zvE2 - this.zs2_2 - this.zs2_3;

      if (this.ustAgVar === 2) {
        this.outNettogehaltMitStAbzug =
          this.zvEMitStAbzug - this.zs2_2MitStAbzug - this.zs2_3MitStAbzug;
      }

      this.outKaufpreis = this.euro(this.dSS.kaufpreis);

      if (this.ustAgVar !== 0) {
        this.outGesKostenLZ1 = this.euro(
          this.outKaufpreis +
            this.getRadVersicherung() +
            this.outLeasingduration * (this.outInspektion * 1.19),
        );
      } else {
        this.outGesKostenLZ1 = this.euro(
          this.outKaufpreis +
            this.getRadVersicherung() +
            this.outLeasingduration * this.outInspektion,
        );
      }

      this.uebernahmepreis = this.euro(this.outuvp * this.uebernahmeprozent);
      if (this.ustAgVar !== 2) {
        this.outGesKostenLZ2 =
          this.sumNettoBelastungTotal() + this.outuvp * this.uebernahmeprozent;
      } else {
        this.outGesKostenLZ2 = this.euro(
          this.sumNettoBelastungTotalOhneVorsteuer() +
            this.sumNettoBelastungTotalMitVorsteuer() +
            this.outuvp * this.uebernahmeprozent,
        );
      }
      this.outErsparnisRel = this.euro(
        ((this.outGesKostenLZ2 / this.outGesKostenLZ1) * 100 - 100) * -1,
      );
      this.outErsparnisFix = this.euro(
        this.outGesKostenLZ1 - this.outGesKostenLZ2,
      );
      this.uebernahmepreis = this.euro(this.outuvp * this.uebernahmeprozent);
    } else {
      console.error('Etwas Fehlt!!');
    }

    this.schowResult();
  }

  beamte1() {
    if (this.dSS.bArt === 0) {
      if (this.kvValueVar === 'pvo') {
        this.outAV1 = 0;
        this.outAV2 = 0;
        this.outAV2MitStAbzug = 0;
        this.outVBLbeitrag1 = 0;
        this.outVBLbeitrag2 = 0;
        this.outRV1 = 0;
        this.outRV2 = 0;
        this.outRV2MitStAbzug = 0;
        this.outKV1 = 0;
        this.outKV2 = 0;
        this.outKV2MitStAbzug = 0;
        this.outPV1 = 0;
        this.outPV2 = 0;
        this.outPV2MitStAbzug = 0;
        this.outPV2 = 0;
        this.outAV2MitStAbzug = 0;
      }
    }
  }

  beamtegesetzlichKV() {
    if (this.dSS.bArt === 0) {
      this.outKV1 = (this.dSS.rsValue / 100) * this.zvE;
      this.outKV1 += (this.dSS.zusatzValue / 100 / 2) * this.zvE;
      this.outKV2 = (this.dSS.rsValue / 100) * this.zvE2;
      this.outKV2 += (this.dSS.zusatzValue / 100 / 2) * this.zvE2;
      if (this.ustAgVar === 2) {
        this.outKV2MitStAbzug = (this.dSS.rsValue / 100) * this.zvEMitStAbzug;
        this.outKV2MitStAbzug +=
          (this.dSS.zusatzValue / 100 / 2) * this.zvEMitStAbzug * 12;
      }
    }
  }

  beamtepflegeversicherung() {
    if (this.dSS.bArt === 0) {
      this.outPV1 = this.zvE * 0.02025;
      this.outPV2 = this.zvE2 * 0.02025;
      if (this.ustAgVar === 2) {
        this.outPV2MitStAbzug = this.zvEMitStAbzug * 0.02025;
      }

      if (this.dSS.dienststelle.bundesland !== 'sn') {
        this.outPV1 += this.zvE * 0.01;
        this.outPV2 += this.zvE2 * 0.01;
        if (this.ustAgVar === 2) {
          this.outPV2MitStAbzug += this.zvEMitStAbzug * 0.01;
        }
      }
      if (this.dSS.kinderValue === 0) {
        this.outPV1 += 0.0025 * this.zvE;
        this.outPV2 += 0.0025 * this.zvE2;
        if (this.ustAgVar === 2) {
          this.outPV2MitStAbzug += 0.0025 * this.zvEMitStAbzug;
        }
      }
    }
  }

  KrankenversicherungBeamte1() {
    if (this.kvValueVar === 'pvo') {
      this.outKV1 = 0;
      this.outKV2 = 0;
      this.outpvsumm = this.dSS.pkvValue;
    }
  }

  berechneVollKasko() {
    let index;
    if (this.dSS.dienststelle.verGeber === 'BARMENIA') {
      index = this.dSS.dienststelle.versicherungNetto
        ? this.getVerRateBarmenia(
            this.dSS.getKaufpreis() / (this.dSS.useNetBikePrice ? 1 : 1.19),
          )
        : this.getVerRateBarmenia(this.dSS.getKaufpreis());
    } else {
      index = this.getVerRateHepster(this.dSS.getKaufpreis());
    }

    if (this.inputValue === 'Muster-2023') {
      this.outVersAN = 0;
      this.Premiumplus = 0;
      this.outVersANVergleich = 0;
      return;
    }

    if (!this.dSS.radFahrSchutz) {
      this.outVersAN = 0;
      this.outVersANVergleich = 0;
      return;
    }

    // Vivantes-Sonderfall zuerst prüfen
    if (this.dSS.isVivantes() && this.dSS.dienststelle.verGeber === 'HEPSTER') {
      index = this.getVerRateHepster(
        this.dSS.getKaufpreis() / (this.dSS.useNetBikePrice ? 1 : 1.19),
      );
      const typ1 = 0;
      const typ2 = 0.00313;
      const typ3 = 0.00177;
      // 1 ist Basis und 2 ist Flex
      if (this.dSS.dienststelle.inspektion === 1) {
        this.outVersAN =
          this.B_STAFFELUNG[index] +
          (this.dSS.getKaufpreis() / (this.dSS.useNetBikePrice ? 1 : 1.19)) *
            typ3 +
          1;
        this.outVersANVergleich = this.outVersAN;
      } else {
        // 1.46 + 0.83 + 1
        this.outVersAN =
          this.euro(
            (this.dSS.getKaufpreis() / (this.dSS.useNetBikePrice ? 1 : 1.19)) *
              typ2,
          ) +
          this.euro(
            (this.dSS.getKaufpreis() / (this.dSS.useNetBikePrice ? 1 : 1.19)) *
              typ3,
          ) +
          1;
        this.outVersANVergleich = this.outVersAN;
      }
      return;
    }

    // Premium X Ride (new logic)
    if (
      this.dSS.dienststelle.verGeber === 'HEPSTER' &&
      this.dSS.dienststelle.versicherungType?.toLowerCase() === 'premium'
    ) {
      const bikePrice =
        this.dSS.getKaufpreis() / (this.dSS.useNetBikePrice ? 1 : 1.19);
      const hepsterRate = 0.00313;
      const kasko = 0.00282;

      this.outVersAN = this.euro((hepsterRate + kasko) * bikePrice + 1);
      this.outVersANVergleich = this.outVersAN;
      return;
    }

    // Standard logic (Upgrade)
    const bikeType =
      typeof this.dSS.bikeCategory === 'number'
        ? this.dSS.bikeCategory
        : (this.dSS.bikeCategory as BikeCategory) ===
          BikeCategory.E_BIKE_PEDELEC;

    this.outVersAN =
      this.versicherungValue[this.dSS.dienststelle.verGeber][bikeType ? 1 : 0][
        index
      ];

    this.Premiumplus =
      this.PremiumplusValue[this.dSS.dienststelle.verGeber][index];

    this.outVersANVergleich = this.outVersAN;
  }

  getVerRateBarmenia(preis: number) {
    if (preis >= 10000) {
      return 19;
    } else if (preis >= 9500) {
      return 18;
    } else if (preis >= 9000) {
      return 17;
    } else if (preis >= 8500) {
      return 16;
    } else if (preis >= 8000) {
      return 15;
    } else if (preis >= 7500) {
      return 14;
    } else if (preis >= 7000) {
      return 13;
    } else if (preis >= 6500) {
      return 12;
    } else if (preis >= 6000) {
      return 11;
    } else if (preis >= 5500) {
      return 10;
    } else if (preis >= 5000) {
      return 9;
    } else if (preis >= 4500) {
      return 8;
    } else if (preis >= 4000) {
      return 7;
    } else if (preis >= 3500) {
      return 6;
    } else if (preis >= 3000) {
      return 5;
    } else if (preis >= 2500) {
      return 4;
    } else if (preis >= 2000) {
      return 3;
    } else if (preis >= 1500) {
      return 2;
    } else if (preis >= 1000) {
      return 1;
    } else {
      return 0;
    }
  }

  // TODO optimize with % and /
  getVerRateHepster(preis: number) {
    if (preis <= 500) {
      return 0;
    } else if (preis <= 1000) {
      return 1;
    } else if (preis <= 1500) {
      return 2;
    } else if (preis <= 2000) {
      return 3;
    } else if (preis <= 2500) {
      return 4;
    } else if (preis <= 3000) {
      return 5;
    } else if (preis <= 3500) {
      return 6;
    } else if (preis <= 4000) {
      return 7;
    } else if (preis <= 4500) {
      return 8;
    } else if (preis <= 5000) {
      return 9;
    } else if (preis <= 5500) {
      return 10;
    } else if (preis <= 6000) {
      return 11;
    } else if (preis <= 6500) {
      return 12;
    } else if (preis <= 7000) {
      return 13;
    } else if (preis <= 7500) {
      return 14;
    } else if (preis <= 8000) {
      return 15;
    } else if (preis <= 8500) {
      return 16;
    } else if (preis <= 9000) {
      return 17;
    } else if (preis <= 9500) {
      return 18;
    } else if (preis <= 10000) {
      return 19;
    }
  }

  berechneUmwandlungsRate() {
    this.zvE2 =
      this.outBruttoMonat -
      this.outInspektion -
      this.outVersAN1 +
      this.outAGAnteil +
      this.outGwV -
      this.outLeasingrate -
      this.outOnePercent;
  }

  berechneUmwandlungsRateAbzug() {
    this.zvEMitStAbzug =
      this.outBruttoMonat -
      this.outInspektion / 1.19 -
      this.outVersAN1 +
      this.outAGAnteil +
      this.outGwV -
      this.outLeasingrate / 1.19 +
      this.outAGAnteil / 1.19 -
      this.outOnePercentAbzug;
  }

  berechneRentenVersicherung() {
    if (this.rvValueVar === false) {
      this.outRV1 = 0;
      this.outRV2 = 0;
      this.outRV2MitStAbzug = 0;
      return;
    }
    if (this.zvE > this.rvBG) {
      this.outRV1 = this.rvBG * this.varRV;
    } else {
      this.outRV1 = this.varRV * this.zvE;
    }
    if (this.zvE2 > this.rvBG) {
      this.outRV2 = this.rvBG * this.varRV;
      this.outRV2MitStAbzug = this.rvBG * this.varRV;
    } else {
      this.outRV2 = this.varRV * this.zvE2;
    }
    if (this.ustAgVar === 2) {
      if (this.zvEMitStAbzug > this.rvBG) {
        this.outRV2MitStAbzug = this.rvBG * this.varRV;
      } else {
        this.outRV2MitStAbzug = this.varRV * this.zvEMitStAbzug;
      }
    }
  }

  // TODO in a angular pipe umwandlen (viel optimierter wegen Pure Functions Caching mechanism in Angular)
  euro(value): number {
    return Number(parseFloat(value).toFixed(2));
  }

  formatNumber(num) {
    return num.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  createPDF() {
    const fairbetrag = this.formatNumber(this.outAGAnteil);

    if (this.modusSpezial) {
      const dd = {
        content: [
          {
            image: this.logoForPDFBase64,
            width: 150,
          },
          { text: '\nDienststellencode: ' + this.dSS.dsCode + '\n' },
          {
            style: '',
            table: {
              widths: ['*', 100, '*'],
              headerRows: 1,
              body: [
                [
                  { text: 'Vergleich', style: 'tableHeader' },
                  { text: 'Direktkauf', style: 'tableHeader' },
                  { text: 'Entgeltumwandlung', style: 'tableHeader' },
                ],
                [
                  { text: '', fillColor: '#548235' }, // Make the cell's background green
                  { text: '', fillColor: '#548235' }, // Make the cell's background green
                  { text: '', fillColor: '#548235' }, // Make the cell's background green
                ],
                [
                  { text: 'Bruttomonatsentgelt', bold: true },
                  {
                    text: this.formatNumber(this.outBruttoMonat) + ' €',
                    bold: true,
                  },
                  {
                    text: this.formatNumber(this.outBruttoMonat) + ' €',
                    bold: true,
                  },
                ],
                [
                  'Leasingrate',
                  '',
                  '- ' + this.formatNumber(this.outLeasingrate) + ' €',
                ],
                [
                  'RadimDienst RadFahrSchutz ',
                  '',
                  '- ' + this.formatNumber(this.outVersAN1) + '€',
                ],
                [
                  ' RadimDienst Inspektionspaket',
                  '',
                  this.dSS.dienststelle.inspektion !== 0
                    ? this.ustAgVar === 1
                      ? '- ' +
                        this.formatNumber(
                          this.dSS.dienststelle.sonderInspektion / 1.19,
                        ) +
                        '€'
                      : '- ' +
                        this.formatNumber(
                          this.dSS.dienststelle.sonderInspektion,
                        ) +
                        '€'
                    : '- ' + '0' + '€',
                ],
                ['Fairbetrag', '', '+ ' + fairbetrag + ' €'],
                [
                  this.dSS.dienststelle.oneProzentNetto === 0
                    ? '1%-USt. auf den Ausgangsumsatz'
                    : '',
                  '',
                  this.dSS.dienststelle.oneProzentNetto === 0
                    ? '- ' + this.formatNumber(this.outOnePercent) + ' €'
                    : '',
                ],
                [
                  ['Gesamtrate'],
                  [''],
                  [
                    '-' +
                      this.formatNumber(this.zvE - this.zvE2 + this.outGwV) +
                      ' €',
                  ],
                ],
                [
                  'Geldwerter Vorteil (gwV)',
                  '',
                  '+ ' + this.formatNumber(this.outGwV) + ' €',
                ],

                ['', '', ''],
              ],
            },
            layout: {
              headerLineOnly: true,
              hLineWidth(i, node) {
                return i === 0 ? 1 : 0;
              },
              vLineWidth(i, node) {
                return i === 0 || i === node.table.widths.length ? 1 : 0;
              },
              hLineColor(i, node) {
                return i === 0 ? 'white' : 'white';
              },
              vLineColor(i, node) {
                return i === 0 || i === node.table.widths.length
                  ? 'white'
                  : 'white';
              },
              paddingLeft(i, node) {
                return i === 0 ? 0 : 8;
              },
              paddingRight(i, node) {
                return i === node.table.widths.length - 1 ? 0 : 8;
              },
            },
          },
          {
            style: '',
            table: {
              widths: ['*', 100, '*'],
              headerRows: 1,
              body: [
                [
                  { text: '', fillColor: '#548235' }, // Make the cell's background green
                  { text: '', fillColor: '#548235' }, // Make the cell's background green
                  { text: '', fillColor: '#548235' }, // Make the cell's background green
                ],
                [
                  ['Gesamtumwandlungsrate'],
                  [''],
                  ['-' + this.formatNumber(this.zvE - this.zvE2) + ' €'],
                ],
                [
                  { text: 'Steuer-/SV-pflichtiges Entgelt', bold: true },
                  { text: this.formatNumber(this.zvE) + ' €', bold: true },
                  { text: this.formatNumber(this.zvE2) + ' €', bold: true },
                ],
              ],
            },
            layout: {
              headerLineOnly: true,
              hLineWidth(i, node) {
                return i === 0 ? 1 : 0;
              },
              vLineWidth(i, node) {
                return i === 0 || i === node.table.widths.length ? 1 : 0;
              },
              hLineColor(i, node) {
                return i === 0 ? 'white' : 'white';
              },
              vLineColor(i, node) {
                return i === 0 || i === node.table.widths.length
                  ? 'white'
                  : 'white';
              },
              paddingLeft(i, node) {
                return i === 0 ? 0 : 8;
              },
              paddingRight(i, node) {
                return i === node.table.widths.length - 1 ? 0 : 8;
              },
            },
          },
          {
            style: '',
            table: {
              widths: ['*', 100, '*'],
              headerRows: 1,
              body: [
                [
                  { text: '', fillColor: '#548235' }, // Make the cell's background green
                  { text: '', fillColor: '#548235' }, // Make the cell's background green
                  { text: '', fillColor: '#548235' }, // Make the cell's background green
                ],
                [
                  'Lohnsteuer',
                  '- ' + this.formatNumber(this.outlSt1) + ' €',
                  '- ' + this.formatNumber(this.outlSt2) + ' €',
                ],
                [
                  'Kirchensteuer',
                  '- ' + this.formatNumber(this.outKiSt1) + ' €',
                  '- ' + this.formatNumber(this.outKiSt2) + ' €',
                ],
                [
                  'Rentenversicherung',
                  '- ' + this.formatNumber(this.outRV1) + ' €',
                  '- ' + this.formatNumber(this.outRV2) + ' €',
                ],
                [
                  'Krankenversicherung',
                  '- ' + this.formatNumber(this.outKV1) + ' €',
                  '- ' + this.formatNumber(this.outKV2) + ' €',
                ],
                [
                  'Pflegeversicherung',
                  '- ' + this.formatNumber(this.outPV1) + ' €',
                  '- ' + this.formatNumber(this.outPV2) + ' €',
                ],
                [
                  'Arbeitslosenversicherung',
                  '- ' + this.formatNumber(this.outAV1) + ' €',
                  '- ' + this.formatNumber(this.outAV2) + ' €',
                ],
                [
                  this.dSS.dienststelle.oneProzentNetto
                    ? '1%-USt. auf den Ausgangsumsatz'
                    : '',
                  '',
                  '- ' + this.formatNumber(this.outOnePercentNetto) + ' €',
                ],
                [
                  'Zusatzversorgung',
                  '- ' + this.formatNumber(this.outVBLbeitrag1) + ' €',
                  '- ' + this.formatNumber(this.outVBLbeitrag2) + ' €',
                ],
                [
                  'abzgl. versteuerter gwV',
                  '',
                  '- ' + this.formatNumber(this.outGwV) + ' €',
                ],
                [
                  { text: 'Auszahlungsbetrag', bold: true },
                  {
                    text:
                      '= ' +
                      this.formatNumber(this.auszahlungsbetrag1()) +
                      ' €',
                    bold: true,
                  },
                  {
                    text:
                      '= ' +
                      this.formatNumber(this.auszahlungsbetrag2()) +
                      ' €',
                    bold: true,
                  },
                ],
                ['', '', ''],
                [
                  this.ustAgVar !== 2
                    ? 'Tatsächl. monatliche Nettobelastung AN'
                    : 'Tatsächl. monatlich Nettobelastung AN ohne Vorsteuerabzugsberechtigt',
                  '',
                  this.formatNumber(
                    this.auszahlungsbetrag1() - this.auszahlungsbetrag2(),
                  ) + ' €',
                ],
                [
                  this.ustAgVar === 2
                    ? 'Tatsächl. monatlich Nettobelastung AN mit Vorsteuerabzugsberechtigt'
                    : '',
                  '',
                  this.ustAgVar === 2
                    ? this.formatNumber(
                        this.auszahlungsbetrag1() - this.auszahlungsbetrag3(),
                      ) + ' €'
                    : '',
                ],
              ],
            },
            layout: {
              headerLineOnly: true,
              hLineWidth(i, node) {
                return i === 0 ? 1 : 0;
              },
              vLineWidth(i, node) {
                return i === 0 || i === node.table.widths.length ? 1 : 0;
              },
              hLineColor(i, node) {
                return i === 0 ? 'white' : 'white';
              },
              vLineColor(i, node) {
                return i === 0 || i === node.table.widths.length
                  ? 'white'
                  : 'white';
              },
              paddingLeft(i, node) {
                return i === 0 ? 0 : 8;
              },
              paddingRight(i, node) {
                return i === node.table.widths.length - 1 ? 0 : 8;
              },
            },
          },
          {
            style: '',
            table: {
              widths: ['*', 100, '*'],
              headerRows: 1,
              body: [
                [
                  { text: '', fillColor: '#548235' }, // Make the cell's background green
                  { text: '', fillColor: '#548235' }, // Make the cell's background green
                  { text: '', fillColor: '#548235' }, // Make the cell's background green
                ],
                [{ text: 'Übersicht Kosten des Rades', bold: true }, '', ''],
                [
                  this.ustAgVar === 2
                    ? 'Summe Nettobelastung über Leasinglaufzeit ohne Vorsteuerabzugsberechtigung'
                    : 'Kaufpreis / Summe Nettobelastung über Leasinglaufzeit',
                  this.formatNumber(this.outKaufpreis) + ' €',
                  this.formatNumber(
                    this.ustAgVar === 2
                      ? this.sumNettoBelastungTotalOhneVorsteuer()
                      : this.sumNettoBelastungTotal(),
                  ) + ' €',
                ],
                [
                  this.ustAgVar === 2
                    ? 'Summe Nettobelastung über Leasinglaufzeit mit Vorsteuerabzugsberechtigung'
                    : '',
                  this.ustAgVar === 2 ? this.outKaufpreis + ' €' : '',
                  this.ustAgVar === 2
                    ? this.formatNumber(
                        this.sumNettoBelastungTotalMitVorsteuer(),
                      ) + ' €'
                    : '',
                ],
                [
                  this.ustAgVar === 2
                    ? 'Summe Nettobelastung über Leasinglaufzeit Insgesamt'
                    : '',
                  this.ustAgVar === 2 ? this.outKaufpreis + ' €' : '',
                  this.ustAgVar === 2
                    ? this.sumNettoBelastungTotalMitPlusOhneVorsteuer() + ' €'
                    : '',
                ],
                [
                  'Rad-Versicherung',
                  this.formatNumber(this.getRadVersicherung()) + ' €',
                  'inklusive',
                ],
                [
                  ' Inspektionspaket',
                  this.ustAgVar === 1
                    ? this.formatNumber(
                        this.outInspektion * this.outLeasingduration * 1.19,
                      ) + ' €'
                    : this.formatNumber(
                        this.outInspektion * this.outLeasingduration,
                      ) + ' €',
                  this.dSS.dienststelle.inspektion == 1
                    ? 'inklusive'
                    : 'Ohne Inspektion',
                ],
                [
                  { text: 'Übernahmekosten', bold: true },
                  { text: '' },
                  {
                    text: ' ' + this.formatNumber(this.uebernahmepreis) + ' €',
                    bold: true,
                  },
                ],
                [
                  { text: 'Gesamtkosten (nach 36 Monaten)', bold: true },
                  {
                    text: '= ' + this.formatNumber(this.outGesKostenLZ1) + ' €',
                    bold: true,
                  },
                  {
                    text: '= ' + this.formatNumber(this.outGesKostenLZ2) + ' €',
                    bold: true,
                  },
                ],
                ['', '', ''],
              ],
            },
            layout: {
              headerLineOnly: true,
              hLineWidth(i, node) {
                return i === 0 ? 1 : 0;
              },
              vLineWidth(i, node) {
                return i === 0 || i === node.table.widths.length ? 1 : 0;
              },
              hLineColor(i, node) {
                return i === 0 ? 'white' : 'white';
              },
              vLineColor(i, node) {
                return i === 0 || i === node.table.widths.length
                  ? 'white'
                  : 'white';
              },
              paddingLeft(i, node) {
                return i === 0 ? 0 : 8;
              },
              paddingRight(i, node) {
                return i === node.table.widths.length - 1 ? 0 : 8;
              },
            },
          },
          {
            style: '',
            table: {
              widths: ['*', 100, '*'],
              headerRows: 1,
              body: [
                [
                  { text: 'Ersparnis ggü. dem Direktkauf', bold: true },
                  '',
                  {
                    text:
                      this.formatNumber(this.outErsparnisFix) +
                      ' € = ' +
                      this.formatNumber(this.outErsparnisRel) +
                      ' %',
                    bold: true,
                  },
                ],
              ],
            },
            layout: {
              headerLineOnly: true,
              hLineWidth(i, node) {
                return i === 0 ? 1 : 0;
              },
              vLineWidth(i, node) {
                return i === 0 || i === node.table.widths.length ? 1 : 0;
              },
              hLineColor(i, node) {
                return i === 0 ? 'white' : 'white';
              },
              vLineColor(i, node) {
                return i === 0 || i === node.table.widths.length
                  ? 'white'
                  : 'white';
              },
              paddingLeft(i, node) {
                return i === 0 ? 0 : 8;
              },
              paddingRight(i, node) {
                return i === node.table.widths.length - 1 ? 0 : 8;
              },
            },
          },
          ,
          {
            style: '',
            table: {
              widths: ['*', 100, '*'],
              headerRows: 1,
              body: [
                [
                  { text: '', fillColor: '#548235' }, // Make the cell's background green
                  { text: '', fillColor: '#548235' }, // Make the cell's background green
                  { text: '', fillColor: '#548235' }, // Make the cell's background green
                ],
                [[''], [''], ['']],
              ],
            },
            layout: {
              headerLineOnly: true,
              hLineWidth(i, node) {
                return i === 0 ? 1 : 0;
              },
              vLineWidth(i, node) {
                return i === 0 || i === node.table.widths.length ? 1 : 0;
              },
              hLineColor(i, node) {
                return i === 0 ? 'white' : 'white';
              },
              vLineColor(i, node) {
                return i === 0 || i === node.table.widths.length
                  ? 'white'
                  : 'white';
              },
              paddingLeft(i, node) {
                return i === 0 ? 0 : 8;
              },
              paddingRight(i, node) {
                return i === node.table.widths.length - 1 ? 0 : 8;
              },
            },
          },
          {
            fontSize: 10,
            text: 'Hinweis: Diese Berechnung ist eine unverbindliche Darstellung der Kostenersparnis. \n\n',
          },
        ],
        info: {
          title: 'Ersparnis-Rechnung',
          author: 'Andersmacher',
          subject: '',
          keywords: '',
        },
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10],
          },
          body: {
            color: 'green',
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5],
          },
          tableExample: {
            margin: [0, 5, 0, 15],
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
          },
        },
        defaultStyle: {
          // alignment: 'justify'
        },
      };

      const date = new Date();
      this.title =
        date.getDate() +
        '.' +
        (date.getMonth() + 1) +
        '.' +
        date.getFullYear() +
        '  ' +
        date.getHours() +
        ':' +
        date.getMinutes();

      const pdfGenerator = pdfMake.createPdf(dd);
      if (this.isMobileDevice(navigator.userAgent)) {
        pdfGenerator.getBlob((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'Ersparnis-Rechnung ' + this.title + '.pdf';
          a.click();
          window.URL.revokeObjectURL(url);
        });
      } else {
        pdfGenerator.download('Ersparnis-Rechnung ' + this.title + '.pdf');
      }
    } else {
      console.error('PDF könnte nicht erstellt werden!!');
    }
  }

  async loadLocalAssetToBase64() {
    this.http
      .get('./assets/imgs/logo-1.png', { responseType: 'blob' })
      .subscribe((res) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.logoForPDFBase64 = reader.result;
        };
        reader.readAsDataURL(res);
      });
  }

  zuruecksetzen() {
    this.inputValue = '';
  }

  ShowDiv(divVal: string) {
    if (this.currInfo !== divVal) {
      this.currInfo = divVal;
    } else {
      this.currInfo = '';
    }
  }

  modus() {
    this.dSS.modusErweitert = this.dSS.modusErweitert === false;
  }

  isMobileDevice(userAgent: string): boolean {
    const mobileDeviceRegex =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return mobileDeviceRegex.test(userAgent);
  }

  showDetails() {
    this.ergebnis = this.ergebnis === false && this.dataValid();
  }

  schowResult() {
    this.modusSpezial = this.dataValid();
  }

  dataValid() {
    this.isValid = !!(this.dSS.kaufpreis && this.dSS.bruttogehalt);
    return this.isValid;
  }

  capitalizeFirstLetter(str: string): string {
    if (str && str !== '') {
      str = str[0].toUpperCase() + str.slice(1);
      return str;
    } else {
      return '';
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '250px',
      data: { msg: 'Dienststellencode wurde nicht gefunden' },
    });

    let res = false;
    dialogRef.afterClosed().subscribe({
      next: (erg) => {
        res = erg;
      },
      error: (err) => {
        console.error(err);
      },
    });
    return res;
  }

  openDialogDataNotValid() {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '250px',
      data: {
        msg: 'Der Dienststellencode ist nicht korrekt. Bitte nehmen Sie Kontakt auf.',
      },
    });
    let res = false;
    dialogRef.afterClosed().subscribe({
      next: (erg) => {
        res = erg;
      },
      error: (err) => {
        console.error(err);
      },
    });
    return res;
  }

  vorsteuerAbzugsberechtigtDateChange() {
    let dateObj: Date;
    if (this.dSS.selectedDate) {
      dateObj = new Date(this.dSS.selectedDate);
    } else {
      dateObj = new Date();
    }
    const today = new Date();

    if (dateObj.getTime() < today.getTime()) {
      this.differenceInMonths = 0;
      return;
    }

    this.differenceInMonths =
      (dateObj.getFullYear() - today.getFullYear()) * 12 +
      // +1 for month because getMonth return 0 to 11
      (dateObj.getMonth() - today.getMonth()) +
      1;
  }

  onInputChange() {
    if (this.isNameChanged && this.dataValid()) {
      this.dSS.update(this.inputValue);
    }
  }

  getRadVersicherung() {
    if (
      this.dSS.dienststelle.verGeber === 'HEPSTER' ||
      this.dSS.dienststelle.versicherungNetto === 0
    ) {
      return this.euro(this.outVersAN * this.outLeasingduration);
    } else {
      const index = this.getVerRateBarmenia(this.dSS.getKaufpreis());
      const outVerseANBrutto =
        this.versicherungValue[this.dSS.dienststelle.verGeber][
          (this.dSS.bikeCategory as BikeCategory) ===
          BikeCategory.E_BIKE_PEDELEC
            ? 0
            : 1
        ][index];
      return this.euro(outVerseANBrutto * this.outLeasingduration);
    }
  }

  private berechnerDiff() {
    const today = new Date();
    this.differenceInMonths =
      (this.dSS.selectedDate.getFullYear() - today.getFullYear()) * 12 +
      (this.dSS.selectedDate.getMonth() - today.getMonth());
  }

  private dienststelleValid() {
    return !(
      this.dSS.dienststelle.VBL == null ||
      this.dSS.dienststelle.ustAG == null ||
      this.dSS.dienststelle.ustAGBeamte == null ||
      this.dSS.dienststelle.inspektion == null ||
      this.dSS.dienststelle.fairbetrag == null ||
      this.dSS.dienststelle.fairbetragBeamte == null ||
      this.dSS.dienststelle.bundesland == null ||
      this.dSS.dienststelle.oneProzent == null ||
      this.dSS.dienststelle.oneProzentBeamte == null ||
      this.dSS.dienststelle.versicherungNetto == null ||
      this.dSS.dienststelle.verGeber == null ||
      this.dSS.dienststelle.minPreis == null ||
      this.dSS.dienststelle.maxPreis == null ||
      this.dSS.dienststelle.aganteil == null ||
      this.dSS.dienststelle.aganteilBeamte == null ||
      this.dSS.dienststelle.sonderInspektion == null ||
      this.dSS.dienststelle.uebernahmeprozent == null ||
      this.dSS.dienststelle.leasingfaktor == null
    );
  }

  ngOnDestroy(): void {
    if (this.dSS.data$) {
      this.dSS.dataSubject.unsubscribe();
    }
  }

  private lohnSteuer(gehalt): number[] {
    let krv = 0;
    const pkv = this.kvValueVar === 'gkv' ? 0 : this.pvAnteilVar === 0 ? 1 : 2;
    if (this.rvValueVar === false) {
      krv = 1;
    }

    const lohnsteuer = new Lohnsteuer2025Service();
    console.log('STKL', this.dSS.stKlasse);
    lohnsteuer.setStkl(this.dSS.stKlasse);
    lohnsteuer.setZkf(new BigDecimal(this.dSS.kinderValue));
    lohnsteuer.setRe4(new BigDecimal(gehalt * 100));
    lohnsteuer.setPkpv(new BigDecimal(this.pkvValueVar * 100));
    lohnsteuer.setPkv(pkv);
    lohnsteuer.setKrv(krv);
    lohnsteuer.setAlter1(0);
    lohnsteuer.setAf(new BigDecimal(0));
    lohnsteuer.setF(1);
    lohnsteuer.setPvs(0);
    lohnsteuer.setR(this.dSS.kircheValue ? 1 : 0);
    lohnsteuer.setLzzhinzu(new BigDecimal(0));
    lohnsteuer.setPvz(0);
    lohnsteuer.setLzz(2);
    lohnsteuer.setKvz(new BigDecimal(this.dSS.zusatzValue));
    lohnsteuer.MAIN();
    const stges = lohnsteuer
      .getLstlzz()
      .plus(lohnsteuer.getStv())
      .plus(lohnsteuer.getSts());
    const soli = lohnsteuer
      .getSolzlzz()
      .plus(lohnsteuer.getSolzs())
      .plus(lohnsteuer.getSolzv());
    const lst: BigDecimal = stges.plus(soli).div(new BigDecimal(100));
    let BK = lohnsteuer.getBk().round(2, BigDecimal.roundUp).toNumber() / 100;
    BK *= this.getKirchensteuersatz();
    return [lst.round(2, BigDecimal.roundUp).toNumber(), BK];
  }

  private getKirchensteuersatz() {
    if (['bw', 'by'].includes(this.dSS.dienststelle.bundesland)) {
      return 0.08;
    } else {
      return 0.09;
    }
  }

  private berechnePv(zvE) {
    if (this.dSS.olderThan23) {
      if (zvE / 12 > this.KPVBemessungsgrenze) {
        return (
          (this.KPVBemessungsgrenze * 12 * this.pvSatz[this.dSS.anzahlKinder]) /
          100
        );
      }
      if (this.dSS.dienststelle.bundesland !== 'sn') {
        return (zvE * this.pvSatz[this.dSS.anzahlKinder]) / 100;
      } else {
        return (zvE * this.pvSatzSachsen[this.dSS.anzahlKinder]) / 100;
      }
    } else {
      if (zvE > this.KPVBemessungsgrenze) {
        return (this.KPVBemessungsgrenze * (this.pvSatz[0] - 0.6)) / 100;
      }
      return (zvE * (this.pvSatz[0] - 0.6)) / 100;
    }
  }

  private berechneAV(zvE: number) {
    if (zvE > this.aVBG) {
      return this.aVBG * this.varAV;
    } else {
      return zvE * this.varAV;
    }
  }

  private updateFairbetrag() {
    let fairbetrag = this.dSS.dienststelle.fairbetrag;
    let aganteil = this.dSS.dienststelle.aganteil;
    if (this.dSS.bArt === 0) {
      fairbetrag = this.dSS.dienststelle.fairbetragBeamte;
      aganteil = this.dSS.dienststelle.aganteilBeamte;
    }

    switch (fairbetrag) {
      case 0:
        this.outAGAnteil = 0;
        break;
      // TODO Zuschuss  Leasingrate bezuschussen mit nein => max versicherungrate und Inspektion
      // TODO Ja mit Ja ist der zuschuss offen(keine Oberegrenze)
      case 1:
        this.outAGAnteil = Number(aganteil);
        // Wenn kein aganteil gesetzt wurde, aber Leasingrate übernommen werden soll
        if (this.dSS.dienststelle.leasingRateBezuschussen === true) {
          this.outAGAnteil = Number(aganteil);
        }
        // Falls "Leasingrate bezuschussen" deaktiviert, Zuschuss begrenzen
        if (this.dSS.dienststelle.leasingRateBezuschussen === false) {
          if (this.outAGAnteil > this.outVersAN1 + this.outInspektion) {
            this.outAGAnteil = this.outVersAN1 + this.outInspektion;
          }
        }
        break;

      // Versicherung übernehmen
      case 2:
        this.outAGAnteil = this.outVersAN1;
        break;
      // Inspektion übernehmen
      case 3:
        this.outAGAnteil = this.outInspektion;
        break;
      // Versicherung und Inspektion übernehmen
      case 4:
        this.outAGAnteil = this.outVersAN1 + this.outInspektion;
        break;
      // Inspektion und Versicherung bis zur Höhe der Fairbetrag
      case 5:
        this.outAGAnteil = this.outVersAN1 + this.outInspektion;
        // tslint:disable-next-line:no-shadowed-variable
        const erg = Number(
          (this.outLeasingrate -
            this.outGwV +
            this.outInspektion +
            this.outVersAN1) *
            0.1997,
        );
        if (this.outAGAnteil > erg) {
          this.outAGAnteil = erg;
        }
        break;
      //  Fairbetrag komplett
      case 6:
        this.outAGAnteil =
          (this.outLeasingrate -
            this.outGwV +
            this.outInspektion +
            this.outVersAN1) *
          0.1997;
        break;
      // Arbeitgeberanteil + Versicherubngrate + Inspektionsrate
      case 7:
        this.outAGAnteil =
          Number(aganteil) + this.outVersAN1 + this.outInspektion;
        break;
      default:
        this.outAGAnteil = 0;
        break;
    }
  }

  private updateVorsteuerAndOneProzent() {
    const isOneProzent =
      this.dSS.bArt === 0
        ? this.dSS.dienststelle.oneProzentBeamte
        : this.dSS.dienststelle.oneProzent;

    // Vorsteuer Ja ab: 1% wird nur berechnet wenn der AG Vorsteuerabzugsberechtigt ist
    if (this.ustAgVar === 2 && isOneProzent !== 0) {
      this.outOnePercent = 0;
      this.outOnePercentAbzug = (Math.floor(this.outuvp * 0.01) / 1.19) * 0.19;
    } else {
      this.outOnePercent =
        isOneProzent !== 0 ? (Math.floor(this.outuvp * 0.01) / 1.19) * 0.19 : 0;
      this.outOnePercentAbzug = 0;
    }
    this.outOnePercentNetto = 0;
    if (this.dSS.dienststelle.oneProzentNetto) {
      this.outOnePercentNetto = (Math.floor(this.outuvp * 0.01) / 1.19) * 0.19;
    }
  }

  private zuSatzVersorgung(zvE: number) {
    if (zvE > this.rvBG) {
      return (this.VBLVar / 100) * this.rvBG;
    } else {
      return zvE * (this.VBLVar / 100);
    }
  }

  private berechneKV(zvE: number) {
    // schreibe eine Funktion für: outKV1 out KV2  outKV2MitStAbzug
    let kv = 0;
    if (zvE >= this.KPVBemessungsgrenze) {
      kv = this.KPVBemessungsgrenze * (this.dSS.rsValue / 100 / 2.0);
      kv += (this.dSS.zusatzValue / 2 / 100) * this.KPVBemessungsgrenze;
    } else {
      kv = zvE * (this.dSS.rsValue / 100 / 2.0);
      kv += (this.dSS.zusatzValue / 2 / 100) * zvE;
    }
    return kv;
  }

  nettoEntgelt1() {
    return this.euro(this.outNettogehalt1 - this.outVBLbeitrag1);
  }

  nettoEntgelt2() {
    return this.euro(
      this.outNettogehalt2 -
        this.outVBLbeitrag2 -
        this.outOnePercentNetto -
        this.outGwV,
    );
  }

  nettoEntgelt3() {
    return this.euro(
      this.outNettogehaltMitStAbzug -
        this.outVBLbeitragMitStAbzug -
        this.outOnePercentNetto -
        this.outGwV,
    );
  }

  monNettoBelastungOhneVorsteuer() {
    return this.euro(this.auszahlungsbetrag1() - this.auszahlungsbetrag2());
  }

  monNettoBelastungMitVorsteuer() {
    return this.euro(this.auszahlungsbetrag1() - this.auszahlungsbetrag3());
  }

  auszahlungsbetrag1() {
    return this.euro(
      this.nettoEntgelt1() - this.outpvsumm + this.outpkvA + this.dSS.pvAnteil,
    );
  }

  auszahlungsbetrag2() {
    return this.euro(
      this.nettoEntgelt2() - this.outpvsumm + this.outpkvA + this.dSS.pvAnteil,
    );
  }

  auszahlungsbetrag3() {
    return this.euro(
      this.nettoEntgelt3() - this.outpvsumm + this.outpkvA + this.dSS.pvAnteil,
    );
  }

  sumNettoBelastungTotal() {
    return this.euro(
      (this.nettoEntgelt1() - this.nettoEntgelt2()) * this.outLeasingduration,
    );
  }

  sumNettoBelastungTotalOhneVorsteuer() {
    return this.euro(
      this.monNettoBelastungOhneVorsteuer() * this.differenceInMonths,
    );
  }

  sumNettoBelastungTotalMitVorsteuer() {
    return this.euro(
      this.monNettoBelastungMitVorsteuer() *
        (this.outLeasingduration - this.differenceInMonths),
    );
  }

  sumNettoBelastungTotalMitPlusOhneVorsteuer() {
    return this.euro(
      this.sumNettoBelastungTotalOhneVorsteuer() +
        this.sumNettoBelastungTotalMitVorsteuer(),
    );
  }

  /*
   * Chart funktionene
   * hinzufügen vom Chart
   * graphen für die Berechnete Werte
   */
  punktHinzufuegen(neuerX: number, neuerY: number): void {
    const neuerPunkt = { x: neuerX, y: neuerY };
    this.punkte.push(neuerPunkt);
  }

  punktHinzufuegen2(neuerX: number, neuerY: number): void {
    const neuerPunkt = { x: neuerX, y: neuerY };
    this.punkte2.push(neuerPunkt);
  }

  allePunkteAnzeigen(): void {
    this.punkte.forEach((punkt, index) => {});
  }

  zeichneDiagramm(): void {
    const canvas = this.chartCanvas.nativeElement;

    if (this.chart) {
      this.chart.destroy(); // Zerstöre das vorherige Diagramm, bevor du ein neues erstellst
    }

    this.chart = new Chart(canvas, {
      type: 'scatter',
      data: {
        datasets: [
          {
            label: 'Lohnsteuer für Steuerklasse' + this.dSS.stKlasse,
            data: this.punkte,
            backgroundColor: `hsl(${Math.random() * 360}, 100%, 50%)`,
          },
          {
            label: 'Lohnsteuer für Steuerklasse' + this.dSS.stKlasse,
            data: this.punkte2,
            backgroundColor: `hsl(${Math.random() * 360}, 100%, 50%)`,
          },
        ],
      },
      options: {
        scales: {
          x: {
            type: 'linear', // Für die x-Achse
            position: 'bottom',
            title: {
              display: true,
              text: 'Bruttoentgelt',
            },
            ticks: {
              stepSize: 10, // Anpassen des Schrittes für die X-Achse
            },
          },
          y: {
            type: 'linear', // Für die y-Achse
            position: 'left',
            title: {
              display: true,
              text: 'Ersparnisse %',
            },
            ticks: {
              stepSize: 2, // Anpassen des Schrittes für die Y-Achse
            },
          },
        },
      },
    });
  }

  startDiagram(): void {
    Chart.register(...registerables);
    for (let i = 1000; i <= 10000; i += 10) {
      this.dSS.bruttogehalt = i;
      this.berechnen();
      this.punktHinzufuegen(i, this.outErsparnisRel);
      this.punktHinzufuegen2(i, this.outErsparnisFix);
    }
    this.zeichneDiagramm();
    this.punkte = [];
  }

  /*
   * Ende Chart functionen
   * */
  getPriceCategory(bikePrice: number) {
    if (bikePrice < 1000) {
      return '<1000';
    }
    if (bikePrice >= 1000 && bikePrice <= 3500) {
      return '1000-3500';
    }
    if (bikePrice > 3500) {
      return '>3500';
    }
    return '<1000';
  }

  getPricing(
    bikeCategory: BikeCategory,
    bikePrice: number,
  ): {
    leasingfaktor: number;
    uebernahmeprozent: number;
  } | null {
    const priceCategory = this.getPriceCategory(bikePrice);
    const categoryPricing = PRICE_CATEGORY[bikeCategory];
    if (categoryPricing) {
      return categoryPricing[priceCategory] || null;
    }
    return null;
  }

  private getInspectionCustomPreis() {
    return PRICE_CATEGORY_INSPECTION[this.dSS.bikeCategory][
      this.getPriceCategory(
        this.dSS.getKaufpreis() / (this.dSS.useNetBikePrice ? 1 : 1.19),
      )
    ][this.dSS.dienststelle.inspektion];
  }

  getNoSavingTotalBikeCost() {
    return this.euro(
      this.outLeasingduration * this.outLeasingrate + this.uebernahmepreis,
    );
  }
}
